export const FETCH_CONTACTUS_DATA = "FETCH_CONTACTUS_DATA";
export const FETCH_CONTACTUS_SUCCESS = "FETCH_CONTACTUS_SUCCESS";
export const FETCH_CONTACTUS_FAILURE = "FETCH_CONTACTUS_FAILURE";

export const FETCH_CONTACTUS_EDIT_DATA = "FETCH_CONTACTUS_EDIT_DATA";
export const FETCH_CONTACTUS_EDIT_SUCCESS = "FETCH_CONTACTUS_EDIT_SUCCESS";
export const FETCH_CONTACTUS_EDIT_FAILURE = "FETCH_CONTACTUS_EDIT_FAILURE";